import { render, staticRenderFns } from "./APIConsole.vue?vue&type=template&id=2bd8e760&"
import script from "./APIConsole.vue?vue&type=script&lang=js&"
export * from "./APIConsole.vue?vue&type=script&lang=js&"
import style0 from "./APIConsole.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports